import PerfectScrollbar from 'perfect-scrollbar';

export function contactDetail() {
  return {
    restrict: 'E',
    template: require('./contact-detail.directive.html'),
    scope: {
      tab:' <',
      unlinkButtonClickedFn: '&unlinkButtonClicked'
    },
    link: link
  };
}

function link($scope, element) {

  const contactInfoColumn = element.find('.contact-info-column')[0];
  const contactInfoScrollbar = new PerfectScrollbar(contactInfoColumn);
  const interactionsColumn = element.find('.crm-interactions-column')[0];
  const interactionsScrollbar = new PerfectScrollbar(interactionsColumn);
  $scope.$on('$destroy', () => {
    contactInfoScrollbar.destroy();
    interactionsScrollbar.destroy();
  });

}


